export interface IToastMessage {
  title: string;
  text: string | undefined;
}

export interface IToastNotification {
  isShowing: boolean;
  message: IToastMessage;
  type: string;
  setToastData: (message: IToastMessage, type: string) => void;
}

export const TOAST_SCREEN_DURATION = 3000;

export const DEFAULT_TOAST_DATA = {
  isShowing: false,
  message: { text: "", title: "" },
  type: "sucess",
  setToastData: () => {},
};
